import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-vejeboner',
  templateUrl: './vejeboner.page.html',
  styleUrls: ['./vejeboner.page.scss'],
})
export class VejebonerPage implements OnInit {

  constructor(private router: Router, private route: ActivatedRoute) { }

  ngOnInit() {
  }

  ionViewWillEnter() {
    if(this.route.snapshot.queryParams['id'] && this.route.snapshot.queryParams['serialnumber']){
      this.router.navigate([`/vejeboner/vejebon/${this.route.snapshot.queryParams['id']}`], { queryParams: { serialnumber: this.route.snapshot.queryParams['serialnumber'] } });
    }
  }



  backToHomepage() {
    this.router.navigate(['/asb/home']);
  }

}